import { Container, Stack, StackProps } from '@mui/material'
import { FC } from 'react'

const LayoutSectionBody: FC<StackProps> = ({ children, sx = {}, ...stackProps }) => (
  <Stack
    spacing={3}
    sx={{
      padding: { xs: 2, md: 3 },
      ...sx,
    }}
    {...stackProps}
  >
    {children}
  </Stack>
)
interface LayoutSectionProps extends StackProps {
  autoHeight?: boolean
  container?: boolean
}

export const LayoutSection: FC<LayoutSectionProps> = ({
  autoHeight,
  container,
  sx = {},
  ...stackProps
}) =>
  container ? (
    <Container sx={{ flex: autoHeight ? 1 : undefined }}>
      <LayoutSectionBody {...stackProps} sx={sx} />
    </Container>
  ) : (
    <LayoutSectionBody {...stackProps} sx={{ flex: autoHeight ? 1 : undefined, ...sx }} />
  )
